<template>
  <div class="hideTotal">
    <!-- 搜索 -->
    <table-search
      label-width="65px"
      @search="fetchList(1)"
      @reset="handleReset"
    >
      <template v-slot:basic>
        <!-- <el-form-item label="组织">
          <el-select
            v-model="query.marketId"
            placeholder="请选择组织"
          >
            <el-option
              v-for="(item, index) in $key.spotPurchaseSaleInquiry.organization"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item> -->
        <el-form-item label="购销计划">
          <el-input
            v-model="query.goodsCode"
            placeholder="请输入购销计划"
          />
        </el-form-item>
      </template>
    </table-search>
    <!-- 导出 -->
    <inquery-result isTips @export="toDownload" />
    <!-- 表格 -->
    <el-table :data="tableData">
      <el-table-column
        fixed
        label="序号"
        align="center"
        width="70px"
      >
        <template slot-scope="scope">
          {{ scope.$index+1 }}
        </template>
      </el-table-column>
      <!-- <af-table-column
        fixed
        prop="marketName"
        label="组织"
      /> -->
      <af-table-column
        fixed
        prop="signHoldDate"
        label="成交日期"
      />
      <af-table-column
        fixed
        prop="userAccount"
        label="客户"
      />
      <af-table-column
        prop="userName"
        label="客户名称"
      />
      <af-table-column
        prop="areaName"
        label="区域"
      />
      <af-table-column
        prop="sumHoldAmount"
        label="总订货量"
      />
      <af-table-column
        prop="netHoldAmount"
        label="净订货量"
      />
      <af-table-column
        prop="buyHoldAmount"
        label="采购订货量"
      />
      <af-table-column
        prop="buyAvgPrice"
        label="采购均价"
      />
      <af-table-column
        prop="buyFrozenBailBalance"
        label="基本担保履约资金(采购)"
      />
      <af-table-column
        prop="buyHoldGainLoss"
        label="补充担保履约资金(采购)"
      />
      <af-table-column
        prop="buyFrozenAmount"
        label="采购冻结量"
      />
      <af-table-column
        prop="buyLockedAmount"
        label="采购锁单量"
      />
      <af-table-column
        prop="sellHoldAmount"
        label="销售订货量"
      />
      <af-table-column
        prop="sellAvgPrice"
        label="销售均价"
      />
      <af-table-column
        prop="sellFrozenBailBalance"
        label="基本担保履约资金(销售)"
      />
      <af-table-column
        prop="sellHoldGainLoss"
        label="补充担保履约资金(销售)"
      />
      <af-table-column
        prop="sellFrozenAmount"
        label="销售冻结量"
      />
      <af-table-column
        prop="sellLockedAmount"
        label="销售锁单量"
      />
      <el-table-column label="操作">
        <template slot-scope="scope">
          <span
            class="detail-color"
            @click="open(scope.row)"
          >详情</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      layout="total, prev, pager, next"
      :current-page.sync="currentPage"
      :total="total"
      background
      @current-change="changePage"
    />
    <!-- 详情 -->
    <detail
      v-if="isShow"
      :row="row"
      @shutDown="shutDown"
    />
  </div>
</template>
<script>
import api from '@/api'
import detail from './components/detail'

function Query () {
  this.marketId = '000' // 组织编号
  this.goodsCode = '' // 购销计划
}
export default {
  name: 'ArbitrageOrderInquiry',
  components: {
    detail
  },
  data () {
    return {
      query: new Query(),
      isShow: false,

      currentPage: 1,
      total: 0,
      pageSize: 10,
      row: {},
      marketId: '',
      tableData: [], // 表格数据
    }
  },
  mounted () {
    this.fetchList(1)
  },
  methods: {
    // 分页查询
    async fetchList (currentPage, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentPage = currentPage || this.currentPage || 1
      let param = {
        ...this.query,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      let res = await api.spotPurchaseSaleInquiry.ArbitrageOrderInquiry(param)
      this.total = res.data.totalItem
      this.tableData = res.data.items
      this.marketId = this.query.marketId
    },
    // 重置搜索
    handleReset () {
      this.query = new Query()
      this.fetchList(1)
    },
    open (row) {
      this.row = row
      this.isShow = true
    },
    // 关闭弹窗
    shutDown () {
      this.isShow = false
    },
    // 导出
    toDownload () {
      let param = {
        marketId: this.marketId,
        execlType: '05',
        excelHead: [
          // {
          //   fieldLabel: '组织',
          //   excelColumn: 'marketName'
          // },
          {
            fieldLabel: '成交日期',
            excelColumn: 'signHoldDate'
          },
          {
            fieldLabel: '客户',
            excelColumn: 'userAccount'
          },
          {
            fieldLabel: '客户名称',
            excelColumn: 'userName'
          },
          {
            fieldLabel: '区域',
            excelColumn: 'areaName'
          },
          {
            fieldLabel: '总订货量',
            excelColumn: 'sumHoldAmount'
          },
          {
            fieldLabel: '净订货量',
            excelColumn: 'netHoldAmount'
          },
          {
            fieldLabel: '采购订货量',
            excelColumn: 'buyHoldAmount'
          },
          {
            fieldLabel: '采购均价',
            excelColumn: 'buyAvgPrice'
          },
          {
            fieldLabel: '基本担保履约资金(采购)',
            excelColumn: 'buyFrozenBailBalance'
          },
          {
            fieldLabel: '补充担保履约资金(采购)',
            excelColumn: 'buyHoldGainLoss'
          },
          {
            fieldLabel: '采购冻结量',
            excelColumn: 'buyFrozenAmount'
          },
          {
            fieldLabel: '采购锁单量',
            excelColumn: 'buyLockedAmount'
          },
          {
            fieldLabel: '销售订货量',
            excelColumn: 'sellHoldAmount'
          },
          {
            fieldLabel: '销售均价',
            excelColumn: 'sellAvgPrice'
          },
          {
            fieldLabel: '基本担保履约资金(销售)',
            excelColumn: 'sellFrozenBailBalance'
          },
          {
            fieldLabel: '补充担保履约资金(销售)',
            excelColumn: 'sellHoldGainLoss'
          },
          {
            fieldLabel: '销售冻结量',
            excelColumn: 'sellFrozenAmount'
          },
          {
            fieldLabel: '销售锁单量',
            excelColumn: 'sellLockedAmount'
          },
        ]
      }
      this.$utils.getExcelFile(this, api.download, param)
    },
    // 换页
    changePage (page) {
      this.fetchList(page)
    },
  }
}

</script>
<style lang="scss" scoped>
  .hideTotal ::v-deep .el-table__fixed .el-table__fixed-body-wrapper tbody>tr:last-child td:nth-child(3) div,
  .hideTotal ::v-deep .el-table__fixed .el-table__fixed-body-wrapper tbody>tr:last-child td:nth-child(4) div,
  .hideTotal ::v-deep > .el-table .el-table__body-wrapper tbody>tr:last-child td:last-child div,
  .hideTotal ::v-deep > .el-table .el-table__body-wrapper tbody>tr:last-child td:nth-child(10) div,
  .hideTotal ::v-deep > .el-table .el-table__body-wrapper tbody>tr:last-child td:nth-child(16) div {
    display: none;
  }

</style>
